import type { Redemption, Reward } from '@/types/reward';

export const rewardCategories = [
  'All categories',
  'Vouchers',
  'Merch',
  'Exclusive',
  'Perks',
  'Services',
  'Impact',
];

export const rewardStatuses = ['All statuses', 'Active', 'Disabled'];

export const rewards: Reward[] = [
  {
    id: 'rwd-01',
    name: 'Specialty Coffee Voucher',
    description: 'A $12 voucher redeemable at any partner specialty coffee shop. Emailed instantly on approval.',
    category: 'Vouchers',
    pointsCost: 1200,
    stock: 88,
    status: 'active',
    redeemed: 412,
    image:
      'https://readdy.ai/api/search-image?query=Premium%20gift%20card%20for%20a%20specialty%20coffee%20shop%20featuring%20a%20minimal%20flat%20lay%20of%20a%20warm%20amber%20and%20cream%20colored%20card%20with%20subtle%20gold%20foil%20accents%20on%20a%20soft%20light%20neutral%20background%2C%20clean%20product%20photography%2C%20soft%20shadows%2C%20premium%20editorial%20style&width=600&height=600&seq=reward-coffee-01&orientation=square',
  },
  {
    id: 'rwd-02',
    name: '10% Discount Voucher',
    description: 'One-time 10% discount code valid on the member\u2019s next order across any connected platform.',
    category: 'Vouchers',
    pointsCost: 800,
    stock: 250,
    status: 'active',
    redeemed: 336,
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20discount%20voucher%20design%20with%20a%20large%20percentage%20symbol%20in%20warm%20gold%20on%20a%20soft%20cream%20background%20with%20subtle%20geometric%20patterns%2C%20clean%20minimal%20flat%20design%2C%20premium%20editorial%20style%2C%20soft%20shadows&width=600&height=600&seq=reward-discount-01&orientation=square',
  },
  {
    id: 'rwd-03',
    name: 'Branded Merch Bundle',
    description: 'A curated bundle with a canvas tote and organic cotton tee, shipped free to the member\u2019s address.',
    category: 'Merch',
    pointsCost: 2500,
    stock: 42,
    status: 'active',
    redeemed: 128,
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20branded%20merchandise%20bundle%20with%20a%20canvas%20tote%20bag%20and%20cotton%20t-shirt%20in%20warm%20cream%20and%20emerald%20green%20tones%20arranged%20on%20a%20clean%20light%20neutral%20background%2C%20soft%20natural%20lighting%2C%20premium%20product%20photography%2C%20simple%20composition&width=600&height=600&seq=reward-merch-01&orientation=square',
  },
  {
    id: 'rwd-04',
    name: 'VIP Experience',
    description: 'An exclusive behind-the-scenes experience with the founding team, capped at 12 seats per quarter.',
    category: 'Exclusive',
    pointsCost: 5000,
    stock: 12,
    status: 'active',
    redeemed: 47,
    image:
      'https://readdy.ai/api/search-image?query=Exclusive%20VIP%20experience%20concept%20with%20a%20golden%20ticket%20and%20elegant%20theater%20or%20event%20setting%20in%20warm%20amber%20lighting%20on%20a%20soft%20neutral%20background%2C%20premium%20lifestyle%20photography%2C%20cinematic%20mood%2C%20minimal%20composition&width=600&height=600&seq=reward-vip-01&orientation=square',
  },
  {
    id: 'rwd-05',
    name: 'Free Shipping Pass',
    description: 'Unlimited free standard shipping for 30 days on the member\u2019s primary connected platform.',
    category: 'Perks',
    pointsCost: 1500,
    stock: 300,
    status: 'active',
    redeemed: 512,
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20shipping%20box%20concept%20with%20a%20kraft%20cardboard%20parcel%20tied%20with%20natural%20twine%20and%20a%20small%20green%20leaf%20on%20a%20clean%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20premium%20product%20photography%2C%20simple%20elegant%20composition&width=600&height=600&seq=reward-shipping-01&orientation=square',
  },
  {
    id: 'rwd-06',
    name: 'Premium Support Session',
    description: 'A 45-minute one-on-one onboarding and optimization call with a loyalty specialist.',
    category: 'Services',
    pointsCost: 2000,
    stock: 50,
    status: 'active',
    redeemed: 86,
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20a%20video%20call%20support%20session%20with%20a%20headset%20and%20soft%20chat%20bubbles%20in%20warm%20gold%20and%20cream%20tones%20on%20a%20light%20neutral%20background%2C%20clean%20flat%20design%2C%20premium%20editorial%20style&width=600&height=600&seq=reward-support-01&orientation=square',
  },
  {
    id: 'rwd-07',
    name: 'Early Access Badge',
    description: 'A lifetime badge granting first access to new features and limited drops before general release.',
    category: 'Exclusive',
    pointsCost: 3500,
    stock: 30,
    status: 'active',
    redeemed: 63,
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20digital%20badge%20emblem%20with%20a%20subtle%20star%20and%20laurel%20motif%20in%20warm%20gold%20and%20cream%20tones%20on%20a%20soft%20neutral%20background%2C%20clean%20vector%20style%2C%20premium%20editorial%20design%2C%20simple%20elegant%20composition&width=600&height=600&seq=reward-badge-01&orientation=square',
  },
  {
    id: 'rwd-08',
    name: 'Charity Donation',
    description: 'Donate 600 points to a partner charity on the member\u2019s behalf. A thank-you receipt is sent automatically.',
    category: 'Impact',
    pointsCost: 600,
    stock: 9999,
    status: 'disabled',
    redeemed: 214,
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20heart%20and%20open%20hands%20symbol%20in%20warm%20cream%20and%20soft%20green%20tones%20representing%20charitable%20giving%20on%20a%20clean%20light%20neutral%20background%2C%20flat%20design%2C%20premium%20editorial%20style%2C%20simple%20composition&width=600&height=600&seq=reward-charity-01&orientation=square',
  },
];

export const redemptionStatuses = ['All', 'Pending', 'Approved', 'Rejected', 'Fulfilled'];

export const redemptions: Redemption[] = [
  {
    id: 'RDM-2041',
    member: 'Ava Thompson',
    memberId: 'mb-1001',
    reward: 'Specialty Coffee Voucher',
    rewardId: 'rwd-01',
    pointsSpent: 1200,
    status: 'pending',
    platform: 'BloomCommerce',
    note: '',
    requestedAt: '2 min ago',
  },
  {
    id: 'RDM-2040',
    member: 'Liam Chen',
    memberId: 'mb-1002',
    reward: '10% Discount Voucher',
    rewardId: 'rwd-02',
    pointsSpent: 800,
    status: 'pending',
    platform: 'NovaMarket',
    note: '',
    requestedAt: '14 min ago',
  },
  {
    id: 'RDM-2039',
    member: 'Sofia Rossi',
    memberId: 'mb-1003',
    reward: 'VIP Experience',
    rewardId: 'rwd-04',
    pointsSpent: 5000,
    status: 'pending',
    platform: 'Kartel',
    note: 'Member requested the Q3 cohort specifically.',
    requestedAt: '38 min ago',
  },
  {
    id: 'RDM-2038',
    member: 'Noah Patel',
    memberId: 'mb-1004',
    reward: 'Branded Merch Bundle',
    rewardId: 'rwd-03',
    pointsSpent: 2500,
    status: 'approved',
    platform: 'BloomCommerce',
    note: 'Shipping address confirmed.',
    requestedAt: '1 hr ago',
  },
  {
    id: 'RDM-2037',
    member: 'Maya Fischer',
    memberId: 'mb-1005',
    reward: 'Free Shipping Pass',
    rewardId: 'rwd-05',
    pointsSpent: 1500,
    status: 'fulfilled',
    platform: 'Loop',
    note: 'Pass activated on member account.',
    requestedAt: '2 hr ago',
  },
  {
    id: 'RDM-2036',
    member: 'Daniel Okafor',
    memberId: 'mb-1006',
    reward: 'Premium Support Session',
    rewardId: 'rwd-06',
    pointsSpent: 2000,
    status: 'approved',
    platform: 'NovaMarket',
    note: 'Scheduled for Tuesday 3pm.',
    requestedAt: '3 hr ago',
  },
  {
    id: 'RDM-2035',
    member: 'Emma Larsen',
    memberId: 'mb-1007',
    reward: 'VIP Experience',
    rewardId: 'rwd-04',
    pointsSpent: 5000,
    status: 'rejected',
    platform: 'Vantage',
    note: 'Quarterly seats already allocated.',
    requestedAt: '5 hr ago',
  },
  {
    id: 'RDM-2034',
    member: 'Kai Nakamura',
    memberId: 'mb-1008',
    reward: 'Charity Donation',
    rewardId: 'rwd-08',
    pointsSpent: 600,
    status: 'fulfilled',
    platform: 'Kartel',
    note: 'Donation receipt emailed.',
    requestedAt: '7 hr ago',
  },
  {
    id: 'RDM-2033',
    member: 'Isabella Moreau',
    memberId: 'mb-1009',
    reward: 'Early Access Badge',
    rewardId: 'rwd-07',
    pointsSpent: 3500,
    status: 'pending',
    platform: 'Cedar',
    note: '',
    requestedAt: '9 hr ago',
  },
  {
    id: 'RDM-2032',
    member: 'Ethan Brooks',
    memberId: 'mb-1010',
    reward: '10% Discount Voucher',
    rewardId: 'rwd-02',
    pointsSpent: 800,
    status: 'approved',
    platform: 'Loop',
    note: 'Code generated, awaiting member pickup.',
    requestedAt: '11 hr ago',
  },
  {
    id: 'RDM-2031',
    member: 'Priya Sharma',
    memberId: 'mb-1011',
    reward: 'VIP Experience',
    rewardId: 'rwd-04',
    pointsSpent: 5000,
    status: 'fulfilled',
    platform: 'BloomCommerce',
    note: 'Attended the Q2 cohort.',
    requestedAt: '1 day ago',
  },
  {
    id: 'RDM-2030',
    member: 'Marco Bianchi',
    memberId: 'mb-1012',
    reward: 'Free Shipping Pass',
    rewardId: 'rwd-05',
    pointsSpent: 1500,
    status: 'rejected',
    platform: 'Vantage',
    note: 'Duplicate request within the active period.',
    requestedAt: '1 day ago',
  },
];
